/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountStatus
 */
export interface UpdateAccountStatus {
    /**
     * Updated payment account ID
     * @type {string}
     * @memberof UpdateAccountStatus
     */
    id?: string;
    /**
     * Status of the payment account
     * @type {number}
     * @memberof UpdateAccountStatus
     */
    status?: number;
}

/**
 * Check if a given object implements the UpdateAccountStatus interface.
 */
export function instanceOfUpdateAccountStatus(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateAccountStatusFromJSON(json: any): UpdateAccountStatus {
    return UpdateAccountStatusFromJSONTyped(json, false);
}

export function UpdateAccountStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function UpdateAccountStatusToJSON(value?: UpdateAccountStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
    };
}

